import { EntityStatus } from '@portal/entity-services/interfaces';
import { ISearchCriteria } from '@portal/shared/ui/filter/src';
import { PageSize } from '../enums/page-size.enum';
import { SortOrder } from '../enums/sort-order.enum';
import { ISort } from './sort.interface';

export interface IQueryParams {
  start?: number;
  limit?: PageSize;
  currentPage?: number;
  order?: SortOrder;
  sort?: ISort;
  populateParentEntity?: boolean;
  populateEntity?: boolean;
  searchCriteria?: Map<string, ISearchCriteria>;
  status?: EntityStatus[];
  parentId?: string;
  parentIds?: string;
  criteria?: ISearchCriteria[];
}
